import {MessageBase} from './message-base';

export class MessageColumnsVisible  extends MessageBase<MessageColumnsVisible> {
  // tslint:disable-next-line:variable-name
  private _idColumns: string[];

  constructor(idRows: string[]) {
    super(MessageColumnsVisible);

    this._idColumns = idRows;
  }

  public get idColumns(): string[] {
    return this._idColumns;
  }
}
